import inPossession from './brand/phases/inPossession.svg?raw';
import inPossessionWhite from './brand/phases/inPossession-white.svg?raw';
import outOfPossession from './brand/phases/outOfPossession.svg?raw';
import outOfPossessionWhite from './brand/phases/outOfPossession-white.svg?raw';
import attTransition from './brand/phases/attTransition.svg?raw';
import attTransitionWhite from './brand/phases/attTransition-white.svg?raw';
import defTransition from './brand/phases/defTransition.svg?raw';
import defTransitionWhite from './brand/phases/defTransition-white.svg?raw';
import setPiece from './brand/phases/setPiece.svg?raw';
import setPieceWhite from './brand/phases/setPiece-white.svg?raw';
import individual from './brand/phases/individual.svg?raw';
import individualWhite from './brand/phases/individual-white.svg?raw';
import gk from './brand/phases/gk.svg?raw';
import gkWhite from './brand/phases/gk-white.svg?raw';
import type { HypothesisPhase } from '../types';

/**
 * B-7 — the phase-category icon, one per `HypothesisPhase` value (brand kit: *"One file per
 * `HypothesisPhase` value; filenames match the enum exactly"*). First consumers: the setup
 * library's seven groups and the add-pattern phase picker; B-9's discovery rows reuse it.
 *
 * The masters carry hardcoded family colours (possession pair teal, transitions slate, the
 * three specifics orange — the kit's colourway rule), so `currentColor` recolouring cannot
 * apply: the family colour IS the design. Dark theme swaps to the `-white` colourway through
 * the same `.only-light`/`.only-dark` device the Matches empty-state symbol uses (styles.css),
 * because slate strokes on the dark surface would simply vanish.
 *
 * A `Record<HypothesisPhase, …>` keyed map, so a phase added to the enum without an icon here
 * is a compile error rather than an empty box at a pitch (the `Icon.tsx` rationale).
 */

interface Colourways {
  readonly light: string;
  readonly dark: string;
}

const PHASE_ICONS: Record<HypothesisPhase, Colourways> = {
  inPossession: { light: inPossession, dark: inPossessionWhite },
  outOfPossession: { light: outOfPossession, dark: outOfPossessionWhite },
  attTransition: { light: attTransition, dark: attTransitionWhite },
  defTransition: { light: defTransition, dark: defTransitionWhite },
  setPiece: { light: setPiece, dark: setPieceWhite },
  individual: { light: individual, dark: individualWhite },
  gk: { light: gk, dark: gkWhite },
};

/** Decorative (the `Icon` rule): every use sits beside the phase's text label. */
export function PhaseIcon({ phase }: { readonly phase: HypothesisPhase }) {
  const art = PHASE_ICONS[phase];
  return (
    <span className="phase-icon-b" aria-hidden="true">
      <span className="only-light" dangerouslySetInnerHTML={{ __html: art.light }} />
      <span className="only-dark" dangerouslySetInnerHTML={{ __html: art.dark }} />
    </span>
  );
}
